/**
 * Environment configuration for the Cortex frontend.
 *
 * Centralises environment variable access. All env vars must be prefixed
 * with VITE_ to be visible here. Base URLs are relative — the dev server
 * proxies /api to the backend (ports are fixed: frontend 3000, backend 3001;
 * see vite.config.js) and production serves from the same origin.
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

// Helper to construct API endpoints
export const getApiEndpoint = (path) => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${API_BASE_URL}/${cleanPath}`
}

export const config = {
  api: {
    baseUrl: API_BASE_URL,
    auth: {
      token: `${API_BASE_URL}/auth/token`,
      me: `${API_BASE_URL}/auth/me`,
    },
  },
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
}

export default config
